export default {
    cardBin: {
        whiteSpace: "nowrap"
    },
    cardLogo: {
        paddingBottom: "15px"
    }
}